import React, { lazy } from 'react';
import { CreateRoot } from '../../assets/js/react';
const BookingWidget = lazy(() => import("../../assets/js/react/components/booking/widget/booking-widget"));
const PrescriptionsWidget = lazy(() => import("../../assets/js/react/components/prescription/prescriptions-widget"));
const QuoteWidget = lazy(() => import("../../assets/js/react/components/quote/quote-widget"));
const PharmacyFinderWidget = lazy(() => import("../../assets/js/react/components/prescription/pharmacy-finder-widget"));
const FluVoucherWidget = lazy(() => import("../../assets/js/react/components/prescription/flu-voucher-widget"));

const bookElement = document?.getElementById('bookingWidget');
const quoteElement = document?.getElementById('quoteWidget');
const type = bookElement?.getAttribute('data-type') || '';
const quoteType = quoteElement?.getAttribute('data-type') || undefined;
const buttonsVisitData = bookElement?.getAttribute('data-buttons-visit') || null;
const buttonsVideoData = bookElement?.getAttribute('data-buttons-video') || null;
const ButtonsJsonData = {
  visit: buttonsVisitData,
  video: buttonsVideoData,
};
CreateRoot('bookingWidget', <BookingWidget type={type} buttonsData={ButtonsJsonData} />);
CreateRoot('quoteWidget', <QuoteWidget type={quoteType} />);
CreateRoot('prescriptionsWidget', <PrescriptionsWidget />);
CreateRoot('pharmacyFinderWidget', <PharmacyFinderWidget />);
CreateRoot('fluVoucherWidget', <FluVoucherWidget />);
